"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ActionsTricolon = require("../ActionsTricolon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var HeaderStyled = _styledComponents["default"].div.withConfig({
  displayName: "Header__HeaderStyled",
  componentId: "wokyjo-0"
})(["width:", ";min-width:", ";color:white;background-color:", ";"], function (_ref) {
  var width = _ref.width;
  return width;
}, function (_ref2) {
  var width = _ref2.width;
  return width;
}, function (_ref3) {
  var highlighted = _ref3.highlighted;
  return highlighted ? "#566a99" : "#32415e";
});

var HeaderContainer = _styledComponents["default"].div.withConfig({
  displayName: "Header__HeaderContainer",
  componentId: "wokyjo-1"
})(["width:100%;height:100%;display:flex;justify-content:space-around;align-items:center;"]);

var HeaderSubContainer = _styledComponents["default"].div.withConfig({
  displayName: "Header__HeaderSubContainer",
  componentId: "wokyjo-2"
})(["width:100%;display:flex;justify-content:space-around;"]);

var Header = function Header(props) {
  return /*#__PURE__*/_react["default"].createElement(HeaderStyled, props, /*#__PURE__*/_react["default"].createElement(HeaderContainer, null, /*#__PURE__*/_react["default"].createElement(HeaderSubContainer, null, props.caption, props.actions.length > 0 ? /*#__PURE__*/_react["default"].createElement(_ActionsTricolon.ActionsTricolon, _extends({
    tooltipPlacement: "left"
  }, props)) : null), props.children, ' '));
};

exports.Header = Header;
Header.defaultProps = {
  caption: '',
  width: '200px',
  actions: []
};